import React from "react";
import countryInfo from "../../image/project/bookstore.jpg";
import SuperRide from "../../image/project/chat.jpg";
import banCric from "../../image/project/blog.jpg";
import "./Project.css";

const projects = [
  {
    img: banCric,
    title: "Blogify",
    details: "MERN Stack Blog application ",
    link: "https://blogify-henna.vercel.app/auth",
  },
  {
    img: SuperRide,
    title: "Chat Application",
    details: "A chat application using Node.js",
    link: "https://github.com/ehsanmaruf/chatAppByMaruf",
  },
  {
    img: countryInfo,
    title: "Book Store",
    details: "MERN Stack book store project",
    link: "https://github.com/ehsanmaruf/onlineBookStore",
  },
];

const Project = () => {
  return (
    <div id="project" className="project-details container mt-5 d-flex justify-content-center text-link-color">
      <div className="">
        <div className="">
          <h2 class="text-center">Project</h2>
          <hr className="horizantel-line" />
        </div>
        <div className="row">
          {projects.map((project) => (
            <div className="col-md-4 p-4">
              <div className="p-3 text-center border rounded">
                <img className="project-img shadow" src={project.img} alt="" />
                <h4 className="mt-3">{project.title}</h4>
                <p>{project.details}</p>
                <a
                  className="btn btn-info btn-style"
                  href={`${project.link}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  See Project
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
